const chars = 'QWERTYUPASDFGHJKLZXVBM123456789';

const generatePassword = () => new Array(6).fill(0).map(() => chars[Math.floor(Math.random() * chars.length)]).join('');

export default generatePassword;